import { ResizeDownloadState } from "../types/types";
import { initialState } from "store/features/resizeDownload/initialState";

export const reset = (state: ResizeDownloadState) => {
    return initialState;
};
